module.exports = __webpack_public_path__ + "img/linkedin.918d5a11.svg";